// extracted by mini-css-extract-plugin
export default {"lds-roller":"LoadingSpinner_lds-roller__SU4B5"};